import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import {
  deleteExpense,
  deletePayment,
  getExpensesByPg,
  getPaymentsByPg,
  getRoomDetailsByPg,
  getTenantByPg,
  updateTenant,
} from "./apiService";

const PaymentDetails = () => {
  const [roomdetails, setRoomdetails] = useState([]);
  const [tenantdetails, setTenantdetails] = useState([]);
  const [vacancys, setVacancys] = useState();
  const [totalbeds, setTotalbeds] = useState();
  const [pendpayguests, setPendpayguests] = useState([]);
  const { guestId, roomId, pgid } = useAuth();
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [total, setTotal] = useState();
  const [rent, setRent] = useState();
  const [totalexpense, setTotalexpense] = useState();
  const [expenses, setExpenses] = useState([]);
  const [vacantRooms, setVacantRooms] = useState([]);

  useEffect(() => {
    getRoomDetailsByPg(pgid).then((res) => {
      setRoomdetails(res);
    });

    getTenantByPg(pgid).then((res) => {
      setTenantdetails(res);
    });

    getPaymentsByPg(pgid).then((res) => {
      setPayments(res);
    });

    getExpensesByPg(pgid).then((res) => {
      setExpenses(res);
    });
    setRent(0);
  }, [pgid]);

  const handlePendingPayments = () => {
    var bedcount = 0;
    var guestcount = 0;
    var freecount = 0;
    let currentdate = new Date();
    var pendGuests = [];
    var totalamt = 0;
    var totalrent = 0;
    var totalexp = 0;
    var Vrooms = [];

    let date_today = new Date();

    let firstDay = new Date(date_today.getFullYear(), date_today.getMonth(), 1);

    let lastDay = new Date(
      date_today.getFullYear(),
      date_today.getMonth() + 1,
      0
    );

    roomdetails.map((room) => {
      if (room.pgname === pgid) {
        bedcount += room.beds;
        // console.log(bedcount);

        const fguests = tenantdetails.filter((tenant) => {
          return tenant.roomNo === room.id;
        });
        guestcount += Object.keys(fguests).length;

        if (Object.keys(fguests).length < room.beds) {
          Vrooms.push(room);
        }

        // pgId(pg.id);
        // navigate("PaymentDetails");
        tenantdetails.forEach((tenant) => {
          if (tenant.roomNo === room.id) {
            const paymentDate = new Date(tenant.paymentDate);

            if (paymentDate.getTime() <= currentdate.getTime()) {
              pendGuests.push(tenant);
            }

            if (
              paymentDate.getTime() >= firstDay.getTime() &&
              paymentDate.getTime() <= lastDay.getTime()
            ) {
              totalrent += tenant.rentAmt;
            }
          }
          return totalrent;
        });
      }
      return null;
    });

    setRent(totalrent);
    freecount = bedcount - guestcount;
    setVacancys(freecount);
    setTotalbeds(bedcount);
    setVacantRooms(Vrooms);
    // console.log(pendGuests);
    setPendpayguests(pendGuests);

    const fpayments = payments.filter((payment) => {
      return payment.pgname === pgid;
    });

    fpayments.forEach((payment) => {
      const paymentDate = new Date(payment.paymentDate);
      if (
        paymentDate.getTime() >= firstDay.getTime() &&
        paymentDate.getTime() <= lastDay.getTime()
      ) {
        totalamt += payment.pamount;
      }

      return totalamt;
    });
    setTotal(totalamt);
    // console.log(totalamt);

    const fexpenses = expenses.filter((exp) => {
      return exp.pgname === pgid;
    });

    fexpenses.forEach((expense) => {
      const paymentDate = new Date(expense.expDate);
      if (
        paymentDate.getTime() >= firstDay.getTime() &&
        paymentDate.getTime() <= lastDay.getTime()
      ) {
        totalexp += expense.expAmt;
      }

      return totalexp;
    });
    setTotalexpense(totalexp);
  };

  const handleRefreshBtn = () => {
    tenantdetails.forEach((tenant) => {
      const paymentDate = new Date(tenant.paymentDate);

      const pdate = new Date(tenant.joinedDate);
      const cdate = new Date();

      cdate.setDate(pdate.getDate() - 1);
      let ndate = cdate.toISOString().split("T")[0];

      if (paymentDate.toISOString().split("T")[0] !== ndate) {
        let bal = tenant.balAmt + tenant.rentAmt;
        const tenant1 = {
          name: tenant.name,
          mobileno: tenant.mobileno,
          aadharNo: tenant.aadharNo,
          joinedDate: tenant.joinedDate,
          rentAmt: tenant.rentAmt,
          balAmt: bal,
          advAmt: tenant.advAmt,
          paymentDate: ndate,
          paid: tenant.paid,
          pgname: pgid,
          roomNo: tenant.roomNo,
        };
        updateTenant(tenant1, tenant.id);
      }
    });
  };

  const handlePaidStatus = (tenant) => {
    roomId(tenant.roomNo);
    guestId(tenant.id);
    // setPaymentstatus(true);
    navigate("UpdatePayment");
  };

  const handleRemoveExpense = (exp) => {
    deleteExpense(exp.id);
  };

  const handleAddExpense = () => {
    // console.log("adding");
    navigate("/Dashboard/AddExpense");
  };

  const handleRevertPayment = (payment) => {
    const fguest = tenantdetails.filter((tenant) => {
      return (
        tenant.name === payment.pname && tenant.aadharNo === payment.paadhar
      );
    });

    if (Object.keys(fguest).length >= 0) {
      fguest.forEach((guest) => {
        const ubalamt = guest.balAmt + payment.pamount;
        let pdate = new Date(guest.paymentDate);
        pdate.setMonth(pdate.getMonth() - 1);
        let ndate = pdate.toISOString().split("T")[0];

        const tenant = {
          name: guest.name,
          mobileno: guest.mobileno,
          aadharNo: guest.aadharNo,
          joinedDate: guest.joinedDate,
          rentAmt: guest.rentAmt,
          balAmt: ubalamt,
          advAmt: guest.advAmt,
          paymentDate: ndate,
          paid: guest.paid,
          roomNo: guest.roomNo,
        };
        // console.log(tenant);
        updateTenant(tenant, guest.id);
      });
    }

    deletePayment(payment.id);
    navigate("/Dashboard");
  };

  return (
    <div className="container-box">
      <div className="marquee">
        <p>
          To Reflect updated details Please select the below button once you
          selected/changed the PG
        </p>
      </div>
      <button
        className="btn-cls fullbanner-cls"
        onClick={() => handlePendingPayments()}
      >
        Click Here For Payments Details
      </button>
      <div className="btnContainer-cls">
        <div className="banner-cls">Total Vacancies : {vacancys}</div>
        <div className="bannerRight-cls">
          Maximum Guest Capacity : {totalbeds}
        </div>
      </div>
      <div className="lable-container-cls">
        <div className="Room-lable-cls">Vacant Rooms:</div>
        {vacantRooms.map((room) => {
          return (
            <div key={room.id}>
              <div className="Room-lable-cls">{room.roomname}</div>
            </div>
          );
        })}
      </div>
      <div className="container-box">
        <div className="header">
          payment pending List....
          <button className="btn-cls" onClick={() => handleRefreshBtn()}>
            Refresh
          </button>
        </div>
        <table>
          <thead>
            <tr className="PendingLabel-cls">
              <th>Tenant Name</th>
              <th>Mobile No</th>
              <th>Payment Date</th>
              <th>Rent Amount</th>
              <th>Bal Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pendpayguests.map((tenant) => {
              return (
                <tr className="PendingLabel-cls" key={tenant.id}>
                  <td>{tenant.name}</td>
                  <td>{tenant.mobileno}</td>
                  <td>{tenant.paymentDate}</td>
                  <td>{tenant.rentAmt}</td>
                  <td>{tenant.balAmt}</td>
                  <td>
                    <button
                      className="btn-cls"
                      onClick={() => handlePaidStatus(tenant)}
                    >
                      pay
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Outlet />
      </div>
      <div className="container-box">
        <div className="header">payment details</div>
        <div className="btnContainer-cls">
          <div className="banner-cls">Current Month Income : {total}</div>
          <div className="bannerRight-cls">
            Current Month Total Expected Rent : {rent}
          </div>
        </div>
        <table>
          <thead>
            <tr className="PendingLabel-cls">
              <th>Name</th>
              <th>Aadhar</th>
              <th>Amount</th>
              <th>Payment Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {payments.slice(-3).map((payment) => {
              if (payment.pgname === pgid) {
                return (
                  <tr className="PendingLabel-cls" key={payment.id}>
                    <td>{payment.pname}</td>
                    <td>{payment.paadhar}</td>
                    <td>{payment.pamount}</td>
                    <td>{payment.paymentDate}</td>
                    <td>
                      <button
                        className="btn-cls"
                        onClick={() => handleRevertPayment(payment)}
                      >
                        revert
                      </button>
                    </td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      </div>
      <div className="container-box">
        <div className="header">Expense details</div>
        <div className="btnContainer-cls">
          <div className="banner-cls">
            Current Month Expenses : {totalexpense}
          </div>
          <div className="bannerRight-cls bannerRight-btn-cls">
            **Add Your Expenses Here**
            <button className="btn-s-cls" onClick={() => handleAddExpense()}>
              Add
            </button>
          </div>
        </div>
        <table>
          <thead>
            <tr className="PendingLabel-cls">
              <th>Expense Name</th>
              <th>Amount</th>
              <th>Payment Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {expenses.slice(-5).map((exp) => {
              if (exp.pgname === pgid) {
                return (
                  <tr className="PendingLabel-cls" key={exp.id}>
                    <td>{exp.expName}</td>
                    <td>{exp.expAmt}</td>
                    <td>{exp.expDate}</td>
                    <td>
                      <button
                        className="btn-cls"
                        onClick={() => handleRemoveExpense(exp)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      </div>
      ;
    </div>
  );
};

export default PaymentDetails;
